import Pause from '../../Player/Pause';
import Play from '../../Player/Play';
import { useEffect } from 'react';

const Controls = ({ wavesurferRef, isTrackPlaying, setIsTrackPlaying, trackName, trackId, setActiveTrackId, onTrackEnd }) => {
  useEffect(() => {
    const ws = wavesurferRef.current;
    if (!ws) return;

    const handleFinish = () => {
      setIsTrackPlaying(false);
      onTrackEnd?.(trackName + trackId);
    };

    ws.on('finish', handleFinish);

    return () => ws.un('finish', handleFinish);
  }, [wavesurferRef, setIsTrackPlaying, trackName, trackId, onTrackEnd]);

  const togglePlayPause = () => {
    const ws = wavesurferRef.current;
    if (!ws) return;

    if (ws.isPlaying()) {
      ws.pause();
      setIsTrackPlaying(false);
    } else {
      ws.play();
      setIsTrackPlaying(true);
      setActiveTrackId(trackName + trackId);
    }
  };

  return (
    <button className="player_icon icon" onClick={togglePlayPause}>
      {isTrackPlaying ? <Pause /> : <Play />}
    </button>
  );
};

export default Controls;